// extracted by mini-css-extract-plugin
export var float = "mainLayout-module--float--9LnUU";